import { z } from 'zod';

export type ActivityLogForeignKey = {
  key: string;
  value: number;
};

export const ActivityLogTypeEnum = z.enum([
  'CREATE',
  'UPDATE',
  'DELETE',
  'ARCHIVE',
  'DEACTIVATE',
  'ACTIVATE',
  'LINK',
  'UNLINK',
  'ADD',
  'REMOVE',
  'OTHER',
]);
export type ActivityLogType = z.infer<typeof ActivityLogTypeEnum>;

export const ActivityLogTextSchema = z.object({
  logType: ActivityLogTypeEnum,
  entity: z.string(),
  entityId: z.number().optional(),
  value: z.string(),
  metadata: z.object({}).passthrough().optional(),
});
export type ActivityLogTextDto = z.infer<typeof ActivityLogTextSchema>;

export const ActivityLogSchema = z.object({
  id: z.number(),
  accountId: z.string().max(50),
  userId: z.string().max(50),
  logType: ActivityLogTypeEnum,
  text: z.string(),
  changeLog: z.array(ActivityLogTextSchema).optional(),
  currentValue: z.object({}).passthrough().optional(),
  details: z.object({}).passthrough().optional(), // deprecated
  feedbackId: z.number().optional(),
  feedbackFormId: z.number().optional(),
  ideaId: z.number().optional(),
  productId: z.number().optional(),
  customerId: z.number().optional(),
  contactId: z.number().optional(),
  customFieldId: z.number().optional(),
  portalId: z.number().optional(),
  ideaViewId: z.number().optional(),
  createdAt: z.date(),
  updatedAt: z.date(),
  entityName: z.string().optional().nullable(),
  contactName: z.string().optional().nullable(),
});
export type ActivityLogDto = z.infer<typeof ActivityLogSchema>;

export const CreateActivityLogSchema = ActivityLogSchema.omit({
  id: true,
  createdAt: true,
  updatedAt: true,
}).extend({
  changeLog: z.array(ActivityLogTextSchema).default([]).optional(),
});
export type CreateActivityLogDto = z.infer<typeof CreateActivityLogSchema>;
